import React from 'react';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

const OPTIONS = [
  { value: 'system', label: 'Seguir al sistema', short: 'Sistema', Icon: DesktopWindowsRoundedIcon },
  { value: 'light', label: 'Tema claro', short: 'Claro', Icon: LightModeRoundedIcon },
  { value: 'dark', label: 'Tema oscuro', short: 'Oscuro', Icon: DarkModeRoundedIcon },
];

/**
 * Selector de tema.
 *
 * Tres estados y no dos, porque "seguir al sistema" es una eleccion en si
 * misma: quien tiene el portatil en automatico no quiere fijar un tema, quiere
 * que la aplicacion acompane al resto de su escritorio.
 *
 * `variant="labelled"` muestra el texto junto al icono y sirve para pantallas
 * de configuracion; el resto de la aplicacion usa la version compacta.
 */
export default function ThemeToggle({ variant = 'compact', className = '' }) {
  const { preference, setPreference } = useTheme();

  return (
    <div
      className={`ng-theme-toggle ng-theme-toggle--${variant} ${className}`}
      role="radiogroup"
      aria-label="Tema de la interfaz"
    >
      {OPTIONS.map(({ value, label, short, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={label}
            className={`ng-theme-toggle__item ${active ? 'is-active' : ''}`}
            onClick={() => setPreference(value)}
          >
            <Icon />
            {variant === 'labelled' && <span>{short}</span>}
          </button>
        );
      })}
    </div>
  );
}
